// extracted by mini-css-extract-plugin
export var checkbox = "_3k-0";
export var circle = "_3k-3";
export var horizontalContainer = "_3k-7";
export var sm = "_3k-5";
export var switch0 = "_3k-2";
export var switchDisabled = "_3k-8";
export var switchEnabled = "_3k-1";
export var textSwitchContainer = "_3k-9";
export var textSwitchOption = "_3k-a";
export var textSwitchOptionSelected = "_3k-b";
export var verticalContainer = "_3k-6";
export var xs = "_3k-4";